import { ShoppingCartIcon } from '@heroicons/react/outline'

export const AddToCartButton = () => {
    return (
        <button
            data-button-id="add-to-cart"
            type="submit"
            className="inline-flex items-center justify-center rounded-full bg-[linear-gradient(90deg,#ED5C2F,#F28230)] px-[22px] py-3 text-[14.5px] font-semibold text-white shadow-[0_6px_16px_rgba(237,92,47,0.28)] transition-[transform,box-shadow,filter] duration-150 hover:shadow-[0_10px_22px_rgba(237,92,47,0.34)] active:translate-y-[1px] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#F28230]/15"
            aria-haspopup="listbox"
            aria-expanded="true"
            aria-labelledby="listbox-label">
            <ShoppingCartIcon className="h-[18px] w-[18px]" />
            <span className="ml-2">Add to cart</span>
        </button>
    )
}
